import { AppBar, Toolbar, IconButton, Typography, Container } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router-dom";

function License() {

    const history = useHistory();
    const handleBackArrow = () => {
        history.goBack()
    }
  return (
    <div>
      <AppBar>
        <Toolbar>
          <IconButton style={{ color: "white" }} onClick={handleBackArrow}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6">Open Source License</Typography>
        </Toolbar>
      </AppBar>
      <Container style={{marginTop: "200px"}}>
        [license details will go here]
      </Container>
    </div>
  );
}

export default License;
